export default {
      id: "location-blob-usage",
      viewBox: "0 0 321 256",
      url: "../../assets/" + "sprite.svg#location-blob-usage",
      toString: function () {
        return this.url;
      }
    }